module.exports = __webpack_public_path__ + "static/media/logo.099e9741.svg";